export default {
  title: 'Grupos',
  name_placeholder: 'Nome do grupo',
  create: 'Criar',
  devices_count: '{count} tag | {count} tags',
  assign_aria: 'Atribuir tags ao grupo {name}',
  rename_aria: 'Renomear grupo {name}',
  delete_aria: 'Excluir grupo {name}',
  delete_confirm: 'Excluir o grupo "{name}"? As tags continuam existindo.',
  group_devices: 'Tags do grupo',
}
